import { Outlet } from 'react-router';
import DesktopRightSection from '@/components/desktop-right-section';
import { useIsDesktop } from '@/hooks/use-user-platform';

export function PanelLayout() {
  const isDesktop = useIsDesktop();

  if (!isDesktop) return <Outlet />;

  return (
    <div className='flex flex-1'>
      <Outlet />

      <DesktopRightSection />
    </div>
  );
}
